import api from "../global/Api";
import Cookies from "js-cookie";
import { resetNavBarState } from "../global/Utils";
import authEvents from "./AuthEvents";
import i18n from "../../i18n";

const COOKIE_OPTIONS = {
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'strict',
    expires: 2
};

const REFRESH_COOKIE_OPTIONS = {
    ...COOKIE_OPTIONS,
    expires: 4
};

const LANGUAGE_COOKIE_OPTIONS = {
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'strict',
    expires: 365
};


// Login
export const login = async (user, password) => {
    try {
        const response = await api.post("/auth/login", { username: user, password }, { skipAuth: true });

        if (response.data.token) {
            Cookies.set('token', response.data.token, COOKIE_OPTIONS);
            Cookies.set('refreshToken', response.data.refreshToken, REFRESH_COOKIE_OPTIONS);
            Cookies.set('roles', response.data.roles, COOKIE_OPTIONS);
            Cookies.set('username', response.data.username || user, COOKIE_OPTIONS);

            const language = (response.data.language || 'PT').toLowerCase();
            Cookies.set('language', language, LANGUAGE_COOKIE_OPTIONS);
            i18n.changeLanguage(language);

            let sessionId = parseInt(sessionStorage.getItem("sessionId") || "0", 10);
            sessionStorage.setItem("sessionId", (sessionId + 1).toString());
        }

        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.error) {
            throw new Error(error.response.data.error);
        } else {
            throw new Error("Error conecting to server");
        }
    }
}

// Refresh Token
export const refreshToken = async () => {
    const token = getRefreshToken();
    try {
        const response = await api.post("/auth/refresh", { refreshToken: token }, { skipAuth: true });
        if (response.data.token) {
            Cookies.set('token', response.data.token, COOKIE_OPTIONS);
        }
    } catch (error) {
        Cookies.remove('token');
        Cookies.remove('refreshToken');
        Cookies.remove('roles');
        Cookies.remove('username');

        if (error.response && error.response.data && error.response.data.error) {
            throw new Error(error.response.data.error);
        } else {
            throw new Error("Error conecting to server");
        }
    }
}


// Logout
export const logout = async () => {
    const token = getToken();
    if (!token) return;

    try {
        await api.post("/auth/logout");
    } catch (error) {
        console.error("Logout failed", error);
    } finally {
        Cookies.remove('token');
        Cookies.remove('refreshToken');
        Cookies.remove('roles');
        Cookies.remove('username');
        sessionStorage.removeItem("sessionId");
        resetNavBarState();
        authEvents.emit("LOGGED_OUT");
    }
};

// Forgot Password 
export const forgotPassword = async (forgotPasswordRequest)=>{
    await api.post("/auth/forgot-password", forgotPasswordRequest,{ skipAuth: true });
}



// Get Token
export const getToken = () => Cookies.get("token");


// Get Refresh Token
export const getRefreshToken = () => Cookies.get("refreshToken");


// Get Username
export const getUsername = () => Cookies.get("username") || "";

// Get Language
export const getLanguage = () => Cookies.get("language") || "pt";

// Update Language
export const updateLanguage = async (language) => {
    const normalized = language.toUpperCase();
    Cookies.set('language', normalized.toLowerCase(), LANGUAGE_COOKIE_OPTIONS);
    i18n.changeLanguage(normalized.toLowerCase());

    try {
        await api.patch("/auth/language", { language: normalized });
    } catch (error) {
        console.error("Failed to persist language preference", error);
    }
};

export const isAuthenticated = () => {
    return !!getToken();
};
